export { default } from "ember-shiki/services/shiki";
